import { NotificaionsBase }   from "./base";
import { api }       from "apps/api";
import moment from 'moment';
import { Scopes } from "apps/scopes";
import { AddressHashUtil } from 'utilities/address';
import { GOTO_THE_COMMENT } from 'apps/events'

export class NotificaionsReadIndicator extends NotificaionsBase {
  init(){
    super.init();
    this.watch();
    this.listenMount([this.onMountIndicator]);
  }
  onMountIndicator(){
    let elements = this.querySelectorAll('[data-toggle="tooltip"]');
    $(elements).tooltip();
    let hash = AddressHashUtil.parse()
    if(hash.comment_id == null){ return; }
    if(hash.comment_id != this.opts.notable_id){ return; }
    let login_user = Scopes.getCurrentUser()
    if(login_user == null){ return; }
    // let customEvent = new CustomEvent(GOTO_THE_COMMENT, {detail: hash.comment_id})
    // document.dispatchEvent(customEvent);
  }
  onChangeStore(newVal, oldVal, objectPath){
    super.onChangeStore(newVal, oldVal, objectPath);
    if(!oldVal.unread || newVal.unread){ return; }
    let element = this.querySelector('.icon-user');
    let klass = element.getAttribute('class');
    element.setAttribute('class', klass + 'animated jello');
  }
}
riot.mixin('notifications.read-indicator', NotificaionsReadIndicator as riot.TagMixin)
